'use client'

import { useQuery } from '@apollo/client/react'
import { useLocale, useTranslations } from 'next-intl'
import { toCountry, useCountry } from '@/app/country'
import BackButton from '@/components/BackButton'
import {
  CountryConfigDataType,
  GET_COUNTRY_CONFIG
} from '@/graphql/queries/countryConfig'
import { Button } from '@/shared/ui/button'
import { Logo } from '@/shared/ui/logo/logo.ui'
import { PhoneIcon } from '@/shared/components/icons'
import { hotlinePhone } from '@/utils/hotlinePhone'

// Header of the subflow: back button on mobile, logo linked to the showcase site of the country, hotline phone
const Header = () => {
  const t = useTranslations('common')
  const locale = useLocale()
  const domainCountry = useCountry()
  const { data } = useQuery<CountryConfigDataType>(GET_COUNTRY_CONFIG)

  const country = toCountry(data?.countryConfig.countryCode) ?? domainCountry
  const phone = hotlinePhone(data?.countryConfig, country, locale)
  const homeLink =
    country === 'BE'
      ? process.env.NEXT_PUBLIC_HOME_BE
      : process.env.NEXT_PUBLIC_HOME_FR
  const phoneName = `${t('freeCall')} ${phone.label}`

  return (
    <header className='border-b border-[color:var(--gray-200)] bg-white'>
      <div className='flex items-center justify-between p-2 md:h-[72px] md:px-4 md:py-0'>
        <div className='size-11 md:hidden'>
          <BackButton iconOnly />
        </div>
        <a href={homeLink} target='_blank'>
          <Logo size='sm' className='md:hidden' />
          <Logo className='hidden md:inline-flex' />
        </a>
        <Button
          variant='white-flat'
          size='icon'
          nativeButton={false}
          render={<a href={phone.href} aria-label={phoneName} />}
          className='size-11 bg-blue-100 md:hidden'
        >
          <PhoneIcon aria-hidden />
        </Button>
        <Button
          variant='white-flat'
          nativeButton={false}
          render={<a href={phone.href} />}
          className='hidden h-10 bg-blue-100 md:inline-flex'
        >
          <PhoneIcon aria-hidden data-icon='inline-start' />
          {phoneName}
        </Button>
      </div>
    </header>
  )
}

export default Header
